import { render, staticRenderFns } from "./my-book-list.vue?vue&type=template&id=31d16130&scoped=true"
import script from "./my-book-list.vue?vue&type=script&lang=js"
export * from "./my-book-list.vue?vue&type=script&lang=js"
import style0 from "./my-book-list.vue?vue&type=style&index=0&id=31d16130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d16130",
  null
  
)

export default component.exports